<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-system-order-remarks></table-system-order-remarks>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import TableSystemOrderRemarks from './TableGrids/TableSystemOrderRemarks.vue'

export default {
    name: 'SystemOrderRemarks',
    props: {

    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableSystemOrderRemarks,
    },
    data() {
        return {
            page: {
                title: "Order Extra Charges",
            },
            breadcrumbs: [
                { text: "Order Extra Charges", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>
